import React from "react";
import { connect } from "react-redux";
import { ClaimTypeJson } from "../../../DynamicFormsJson/MastersJSON/claimType";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { ClaimTypeColumns } from "../../../tableColumns/table-columns";
import { getAllClaimType } from "../../../Slice/claim.slice";

class ClaimTypeList extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { claimTypeList, getAllClaimType } = this.props;
    return (
      <>
        <DynamicMainScreen
          formPath={ClaimTypeJson.formPath}
          screenTitle={ClaimTypeJson.screenTitle}
          fieldMeta={ClaimTypeJson.fieldMeta}
          showPdfDownload={false}
          showExcelDownload={false}
          pdfFileName={ClaimTypeJson.pdfFileName}
          excelFileName={ClaimTypeJson.excelFileName}
          showAddButton={ClaimTypeJson.showAddButton}
          tableColumnsToFilter={ClaimTypeJson.tableColumnsToFilter}
          tableColumns={ClaimTypeColumns}
          tableData={claimTypeList?.claimType}
          getTableData={getAllClaimType}
          apiBaseURL={ClaimTypeJson.apiBaseURL}
          baseIdColumn={ClaimTypeJson.baseIdColumn}
          showDeleteIcon={true}
          editConditionName="flag"
          editConditionValue="0"
          showViewButtonInTable={true}
          formPathView={ClaimTypeJson.formPathView}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  claimTypeList: state.claim,
});
const mapDispatchToProps = {
  getAllClaimType,
};
export default connect(mapStateToProps, mapDispatchToProps)(ClaimTypeList);
